<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">
                <router-link :to="{ path: '/extra-items'}">
                  <i class="fa fa-long-arrow-alt-left mr-1"></i>
                </router-link>
                {{ $t('sidebar.communications') || 'Communications' }}
              </h3>
            </div>
            <div class="col-auto text-right">
              <div class="btn-group">
                <button
                  hidden=""
                  class="btn btn-white mr-2"
                  @click="toggleFilterDrawer">
                  <i class="fa fa-filter mr-1"></i> Filters
                </button>
                <button type="button" class="btn btn-primary" @click="goToCreateStatementRun()">
                  <i class="fa fa-plus mr-1"></i> New {{ $t('sidebar.communication') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <PageTabs
          hidden="hidden"
          :activeTab="activeTab"
          :tabs="statementTabs"
          :modules="modules"
          :permissions="permissions"
          :locale="$i18n.locale"
        />

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-0">
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter.key"
                            :value="searchFilter.key"
                            :name="searchFilter.key"
                            :selected="searchFilter.key === selectedSearchFilterId">
                            {{ searchFilter.value }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text" v-model="searchValue"
                             @keyup="searchCommunications" placeholder="Search by subject...">
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="table-responsive" ref="communicationContainer">
                  <table id="tblCommunications" class="table table-hover table-center mb-0"
                         :class="windowWidth < 768 ? 'cards': ''">
                    <thead style="background-color: ghostwhite">
                    <tr>
                      <th scope="col" class="text-left">
                        Subject
                      </th>
                      <th scope="col" class="text-left">Date</th>
                      <th scope="col" class="text-left">Scheduled At</th>
                      <th scope="col" class="text-right">
                        Status
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="communications.length">
                    <tr v-for="communication in communications" :key="communication.id">
                      <td col="Subject: "
                          :class="{'text-left': showButton('REPORT_SALES_BY_DAY_READ') && displayDisabledButtons, 'text-right': !showButton('REPORT_SALES_BY_DAY_READ') || !displayDisabledButtons}">
                        {{
                          communication.subject ? communication.subject : '-'
                        }}
                      </td>
                      <td col="Date: " class="text-left">
                        {{ communication.dateCreated ? utcDateToLocal(communication.dateCreated) : '-' }}
                      </td>
                      <td col="Date: " class="text-left">
                        {{ communication.scheduledAt ? utcDateToLocal(communication.scheduledAt) : '-' }}
                      </td>
                      <td col="Status: " class="text-right">
                        <label v-if="communication.status === 'PENDING'" class="badge badge-secondary">PENDING</label>
                        <label v-else-if="communication.status === 'SENT'" class="badge badge-info">SENT</label>
                        <label v-else-if="communication.status === 'SCHEDULED'"
                               class="badge badge-success">APPROVED</label>
                        <label v-else-if="communication.status === 'FAILED'" class="badge badge-danger">FAILED</label>
                        <label v-else class="badge badge-dark">{{ communication.status }}</label>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="row" v-if="communications.length">
                    <div class="col-sm-12 col-md-5">
                      <div class="" id="tblProducts_info" role="status" aria-live="polite" style="padding-top: 1.25em">
                        Show
                        <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                          <option :value="12">12</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        of {{ totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                           style="padding-top: 0.55em">
                        <pagination
                          :totalPages="totalPages"
                          :perPage="recordsPerPage"
                          :currentPage="currentPage"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="!communications.length" class="text-center mt-5 mb-5">
                    <div v-if="!isLoading">No records found!</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Filter Drawer -->
    <CommunicationsFilterDrawer
      :is-open="isFilterDrawerOpen"
      :initial-filters="{ searchFilterId: selectedSearchFilterId, searchValue: searchValue, recordsPerPage: recordsPerPage }"
      :search-filters="searchFilters"
      @close="closeFilterDrawer"
      @filters-updated=""
    />
    <div class="filter-overlay" :class="{ 'show': isFilterDrawerOpen }" @click="closeFilterDrawer"></div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>

import communicationService from "../../service/communication.service";
import permissionService from "../../service/permission.service";
import {getConfig} from "../../utils/config";
import Pagination from "../Pagination.vue";
import {errorCodes} from "../../interceptors/codes";
import {communicationTabs, utcDateToLocal} from "../../utils/utils";
import PageTabs from "../shared/PageTabs.vue";
import {allowedModules} from "../../utils/modules";
import {showWarning} from "../../utils/notification.utils";
import CommunicationsFilterDrawer from "./CommunicationsFilterDrawer.vue";

export default {
  components: {
    CommunicationsFilterDrawer,
    // StatementFilterDrawer,
    PageTabs,
    Pagination,
  },
  data() {
    return {
      communications: [],
      searchValue: "",
      searchFilters: [
        {key: "subject", value: "Subject"},
      ],
      selectedSearchFilterId: "subject",
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 25,
      fullPage: false,
      permissions: {},
      pagePermissions: ['REPORT_SALES_BY_DAY_READ'],
      displayDisabledButtons: !getConfig().hideIfNoPermission,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      isLoading: false,
      activeTab: 'communications',
      statementTabs: [],
      modules: [],
      isFilterDrawerOpen: false,
      useOnlyDrawerFilter: true,
      advancedFilters: null
    };
  },
  methods: {
    utcDateToLocal: utcDateToLocal,
    changeSearchFilter() {
      this.searchCommunications(null)
    },
    toggleFilterDrawer() {
      this.isFilterDrawerOpen = !this.isFilterDrawerOpen;
      if (this.isFilterDrawerOpen) {
        document.body.classList.add('drawer-open');
      } else {
        document.body.classList.remove('drawer-open');
      }
    },
    closeFilterDrawer() {
      this.isFilterDrawerOpen = false;
      document.body.classList.remove('drawer-open');
    },
    goToCreateStatementRun() {
      this.$router.push(`/communications/create`);
    },
    searchCommunications(e) {
      e ? e.preventDefault() : null
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.communicationContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      let params = {
        sortBy: 'dateCreated',
        sortOrder: 'DESC',
        op: 'like',
        page: this.currentPage,
        size: this.recordsPerPage
      }
      if (this.searchValue) {
        params[this.selectedSearchFilterId] = this.searchValue;
      }
      communicationService.find(localStorage.getItem("mid"), params)
        .then(response => {
          this.communications = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          console.log("Error: ", e)
          const code = e.response.status;
          const error = errorCodes[code];
          this.success = false
          this.message = code === 400 ? (e.response.data.description || e.response.data.narrative) : error.description
        }).finally(() => {
        loader.hide()
      })
    },
    retrieveCommunications() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.communicationContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      const params = {
        sort: '-dateCreated',
        page: this.currentPage,
        size: this.recordsPerPage
      }
      communicationService.find(localStorage.getItem("mid"), params)
        .then(response => {
          if (response.data.data == null) {
            this.success = false
            this.message = "No communications found"
            return
          }
          this.communications = response.data.data
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          console.log("Error: ", e)
          const code = e.response.status;
          const error = errorCodes[code];
          this.success = false
          this.message = code === 400 ? (e.response.data.description || e.response.data.narrative) : error.description
        }).finally(() => {
        loader.hide()
      })
    },
    showButton(permission) {
      if (this.permissions[permission]) {
        return true;
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabled(permission) {
      return !this.permissions[permission]
    },
    buttonTooltip(permission) {
      return this.isDisabled(permission) ? 'You do not access to this feature' : ''
    },
    onPageChange(page) {
      this.currentPage = page
      this.retrieveCommunications()
    },
    onChangeRecordsPerPage() {
      this.retrieveCommunications()
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    basedOnWindowWidth() {
      if (this.windowWidth < 768) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login');
      return
    }

    this.modules = allowedModules.filter(module => module.name === this.$i18n.locale)[0].modules;
    this.statementTabs = communicationTabs.filter(statementTab => statementTab.industries.includes(this.$i18n.locale) && statementTab.active);

    const result = await permissionService.checkPermissions(this.pagePermissions)

    if (!result.success) {
      await showWarning('Permission check failed');
      return
    }
    this.permissions = result.data
    this.retrieveCommunications()
  }
}
</script>
<style scoped>
button:disabled {
  cursor: not-allowed
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}

button:disabled {
  cursor: not-allowed
}

.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  display: none;
}

.filter-overlay.show {
  display: block;
}

/* Add this to prevent scrolling when drawer is open */
:global(body.drawer-open) {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/communications/CommunicationList.vue